import "./startup/session-storage-polyfill"; // ⬅️ Toujours avant tout
import React, { useEffect } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "mapbox-gl/dist/mapbox-gl.css";
import "./utils/resetInstallBanner";
import "./startup/deeplink"; // Gestion des deep links
// import "./debug/debug-logger";

// Debug logs pour mobile
console.log("🚀 App starting - main.tsx loaded");

// Global error handling (utile quand écran blanc)
window.addEventListener("error", (e) => {
  console.error("Global error:", e?.error || e?.message);
});
window.addEventListener("unhandledrejection", (e) => {
  console.error("Unhandled promise rejection:", e.reason);
});

// 🔌 Capture des logs IAP natifs via le wrapper centralisé
import * as CapacitorIAP from "./iap/capacitorIAP";

function setupIAPLogs() {
  try {
    if (!CapacitorIAP.ready()) {
      console.warn("⚠️ IAP plugin non détecté (web ou pas encore initialisé)");
      return;
    }
    console.log("✅ IAP plugin détecté, écoute des logs activée");
    const listener = CapacitorIAP.onIapLog((e: any) => {
      const level = (e?.level || "info").toUpperCase();
      const msg = e?.message || "";
      console.log(`[IAP ${level}] ${msg}`, e);
    });
    
    // Cleanup on HMR
    if ((import.meta as any).hot) {
      (import.meta as any).hot.on("vite:beforeFullReload", () => {
        try { listener?.remove?.(); } catch {}
      });
    }
  } catch (err) {
    console.error("Erreur lors de l'activation des logs IAP:", err);
  }
}

setupIAPLogs();

// ----------------------------
// 🚀 Initialisation React
// ----------------------------
try {
  console.log("🎯 Creating React root...");
  const rootElement = document.getElementById("root");
  if (!rootElement) {
    throw new Error("Root element not found");
  }
  console.log("✅ Root element found, rendering App...");
  createRoot(rootElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  console.log("✅ App rendered successfully");
} catch (error) {
  console.error("❌ Failed to render app:", error);
}
